import React from 'react'
import TabsReservationsPatient from './TabsReservationsPatient'

const Index = () => {
    return (
        <TabsReservationsPatient />
    )
}

export default Index
